module.exports = __webpack_public_path__ + "img/search-by-ipv6-prefix.7a042d98.png";